var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',[_vm._v("...")]):(_vm.inspection)?_c('div',[_c('Meeting',{attrs:{"inspection":_vm.inspection}})],1):_c('div',{staticClass:"no-data-card text-center mt-5 mb-4",attrs:{"lg":"3"}},[_vm._v(" "+_vm._s(_vm.$t("messages.information.no_data"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }